/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */

import { gql } from '@apollo/client'

import { SUB_ACTION_GENERATOR_STATS_FRAGMENT } from './SubActionGeneratorStatsFragment'

export const ACTION_GENERATOR_STATS_FRAGMENT = gql`
  fragment ActionGeneratorStats on ActionGeneratorStats {
    id
    title
    description
    repeatSchedule
    startDate
    actionType
    dueDateTime
    numStores
    storeIds
    completionPercentage
    ignoredPercentage
    subGenerators {
      ...SubActionGeneratorStats
    }
  }
  ${SUB_ACTION_GENERATOR_STATS_FRAGMENT}
`
